import axios from 'axios'
import { setupAuthInterceptor } from '@/lib/authInterceptor'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://account-payment-api.hocnhe.com'

const agentAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

setupAuthInterceptor(agentAxios)

export default agentAxios
